import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import { select, Store } from '@ngrx/store';
import { forkJoin } from 'rxjs';
import { take } from 'rxjs/operators';
import { BusinessAccountTypeNameMapping, MarketingAdDto } from 'src/app/core/dtos/dto';
import { BrandEnum } from 'src/app/core/dtos/enum';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { AccountService } from 'src/app/core/services/account.service';
import { BusinessAccountService } from 'src/app/core/services/business-account.service';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { selectBusinessAccountTypeNameMapping } from 'src/app/state/my-account.selectors';


@Component({
  selector: 'app-business-resources',
  templateUrl: './business-resources.component.html',
  styleUrls: ['./business-resources.component.scss']
})
export class BusinessResourcesComponent implements OnInit {
  baseUrl: string;
  brandId: number;
  businessAccountType: BusinessAccountTypeNameMapping;
  resourceLinks = [];
  businessAccountCountryName = "";
  marketingAd: MarketingAdDto;
  marketingAdImage: string;
  isInternational: boolean;
  overviewLink: string;
  bulkOrderLink: string;
  secondResourceLinkTitle: string;
  secondResourceLink: string;
  countries = [
    "CHINA",
    "INDONESIA",
    "THAILAND",
    "INDIA",
    "VIETNAM",
    "PHILIPPINES",
    "UNITED ARAB EMIRATES",
    "MEXICO",
    "BRAZIL",
    "COLOMBIA",
    "KOREA, REPUBLIC OF",
    "JAPAN",
    "NIGERIA",
    "UNITED KINGDOM (ENGLAND, SCOTLAND, WALES, NORTHERN IRELAND)",
    "AUSTRALIA"
  ];

  constructor(
    private accountService: AccountService,
    private businessAccountService: BusinessAccountService,
    private configHelper: ConfigHelper,
    private toastService: HotToastService,
    private store: Store
  ) { }

  ngOnInit(): void {
    this.brandId = this.configHelper.getBrandId();
    this.getBusinessAcountInfo();
    this.getMarketingAd();
  }
  getBusinessAcountInfo() {
    forkJoin([this.businessAccountService.getBusinessAccountCountry(), this.store.pipe(select(selectBusinessAccountTypeNameMapping)).pipe(take(1))])
      .subscribe(
        (result) => {
          this.businessAccountCountryName = result[0].content;
          this.businessAccountType = result[1];
          this.isInternational = this.businessAccountType.resourcesTypeName === "International Agents" || this.businessAccountType.resourcesTypeName === "International Preparation Providers";
          this.getLinks();
        }
        ,
        (error: HttpErrorResponse) => {
          if (error.status !== 401) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            if (errorMessage?.reasons) {
              errorMessage.reasons.forEach(reasons => {
                this.toastService.warning(reasons.errorMessage);
              });
            }
          }
        }
      );
  }

  getMarketingAd() {
    this.accountService.getMarketingAd()
      .subscribe(
        result => {
          if (result) {
            this.marketingAd = result.content;
            this.marketingAdImage = this.accountService.getMarketingAdImageSrc(this.marketingAd.id);
          }
        }
      );
  }

  formatCountryForUrl(countryName: string) {
    const countryMappings = {
      "UNITED ARAB EMIRATES": "uae",
      "UNITED STATES": "usa",
      "KOREA, REPUBLIC OF": "south-korea",
      "UNITED KINGDOM (ENGLAND, SCOTLAND, WALES, NORTHERN IRELAND)": "united-kingdom",
    };
    return countryMappings[countryName] || countryName.toLowerCase();
  }

  getLinks() {
    if (this.brandId === BrandEnum.CELPIP || this.brandId === BrandEnum.CAEL) {
      this.baseUrl = this.brandId === BrandEnum.CELPIP ? "https://www.celpip.ca/" : "https://www.cael.ca/";
      this.overviewLink = this.baseUrl + "network/";
      this.bulkOrderLink = this.baseUrl + (this.brandId === BrandEnum.CELPIP ? "celpip" : "cael") + "-for-stakeholders/prep-providers/order-form/";

      if (this.countries.includes(this.businessAccountCountryName) || (this.isInternational && ["CANADA", "UNITED STATES", "SINGAPORE", "TAIWAN, CHINA"].includes(this.businessAccountCountryName))) {
        this.bulkOrderLink = this.baseUrl + 'order-form/' + ((["TAIWAN, CHINA"].includes(this.businessAccountCountryName)) ? "taiwan" : this.formatCountryForUrl(this.businessAccountCountryName));
      }
      if (this.brandId === BrandEnum.CELPIP && this.isInternational && ["CANADA", "UNITED STATES"].includes(this.businessAccountCountryName)) {
        this.secondResourceLinkTitle = "Tools for Test Taker Registration";
        this.secondResourceLink = this.overviewLink + "registration-tools";
      }
      else {
        this.secondResourceLinkTitle = "Tools to Generate Commission";
        this.secondResourceLink = this.overviewLink + "commission-tools";
      }
      this.resourceLinks.push(
        { title: "Network Overview", link: this.overviewLink },
        { title: this.secondResourceLinkTitle, link: this.secondResourceLink },
        { title: "Marketing Resources", link: this.overviewLink + "marketing-resources" },
      );
      if (this.businessAccountType.resourcesTypeName === "International Preparation Providers") {
        let instructorTrainingLink = this.baseUrl + (this.brandId === BrandEnum.CELPIP ? "celpip" : "cael") + "-for-stakeholders/instructors";
        this.resourceLinks.push(
          { title: "Instructor Training Information", link: instructorTrainingLink },
          { title: "Tools to Prepare Preparation Curriculum", link: this.baseUrl + "network/curriculum-tools" },
          { title: "Materials Bulk Order Form", link: this.bulkOrderLink },
        );
      }
    }
    this.resourceLinks.push(
      { title: "Terms and Conditions", link: "https://www.paragontesting.ca/paragon-legal-agreements-and-policies/" });
  }
}
